import axios from "axios";
import { InputText } from "primereact/inputtext";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";

import styled from 'styled-components';
import { media, spacing } from "../../theme";
import {ReactComponent as PhotoIcon} from '/public/assets/css/ontario-design-system/icons/svg/ontario-icon-photo.svg';
import {ReactComponent as UploadIcon} from '../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-upload.svg';
import {ReactComponent as CloseIcon} from '../../../public/assets/css/ontario-design-system/icons/ontario-icon-close.svg';
import {ReactComponent as UploadedFile} from '/public/assets/css/ontario-design-system/icons/svg/ontario-icon-alert-success.svg';
import {ReactComponent as ViewFile} from '/public/assets/css/ontario-design-system/icons/svg/ontario-icon-password-show.svg';
import {ReactComponent as DeleteFile} from '/public/assets/css/ontario-design-system/icons/svg/ontario-icon-close.svg';
import { VscPreview } from "react-icons/vsc";
import { SlNote } from "react-icons/sl";
import colors from "../../theme/variables/colors";
import { FormSectionElements } from "../../entities/formTemplateDataType";
import { fileTypeList, UploadFileSizeLimit } from "../../entities/Constants";
import ErrorElement from "../../commonComponent/ErrorElement";
import { ModalComponent } from "./ModalComponent";
import { ImageViewerComponent, MsDocViewer, PDFViewerComponent } from "./FilePreviewComponent";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { getRootComponent } from "../../utilities/ElementUtils"; // Added import
import { WarningAlertComponent } from "../odsCalloutBox/WarningAlertComponent";
import { HintExpansionComponent } from "../odsCalloutBox/HintExpansionComponent";
import LoadingOverlay from 'react-loading-overlay';
import { getStyleObjectFromString } from "../../utilities/HtmlUtils";
import "./FileErrorDialog.css";
import { getEnvVar } from "../../config/RuntimeConfig";

const DocumentUploadContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing.spacing7};
    margin-top: ${spacing.spacing7};

    @media ${media.medium} {
        flex-direction: row;
    }
`;

const FileNameContainer = styled.div<{ $background?: string; $minWidth?: string; $maxWidth?: string; }>`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background: ${props => props.$background || '#E2F0F4'};
    box-shadow: ${props => props.$background ? '' : '0px 1px 2px rgba(0, 0, 0, 0.25)'};
    padding: ${props => props.$background ? `${spacing.spacing2} ${spacing.spacing0}` : `${spacing.spacing2} ${spacing.spacing2} ${spacing.spacing2} ${spacing.spacing4}`};
    min-width: ${props => props.$minWidth || '300px'};
    gap: ${spacing.spacing4};
    max-width: ${props => props.$maxWidth || '400px'};
    width: 100%;
    font-size: 0.9rem;

    // @media ${media.medium} {
    //     gap: ${spacing.spacing5};
    // }

    .close-icon {
        cursor: pointer;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
    }
    
    &:hover {
        background: ${props => props.$background ? '#ffffff;' : '#C2E0FF;' };
    }
`;

const FileNameDiv = styled.div`
    display: flex;
    align-items: flex-start;
    word-break: break-word;
    flex-wrap: wrap;
    gap: ${spacing.spacing1};
    
    
    // @media ${media.medium} {
    //     gap: ${spacing.spacing1};
    // };

    svg: {
        width: 24px;
        height: 24px;
        path {
            fill: {colors.btnPrimaryBG};
        }
    }
`;

export const StyledPhotoIcon = styled(PhotoIcon)`
    flex-shrink: 0;
    path {
        fill: ${colors.btnPrimaryBG};
    }

    width: 24px;
    height: 24px;
`;

const StyledStatusIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: white;
    font-weight: bold;
    flex-shrink: 0;

    &.ontario-icon-success {
        background-color: #28a745;
        font-size: 14px;
    }

    &.ontario-icon-error {
        background-color: #d8292f;
        font-size: 16px;
    }
`;

const UploadButton = styled.button<{ $isDragOver?: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: ${spacing.spacing4};
    border: 2px dashed ${props => props.$isDragOver ? colors.btnPrimaryBG : colors.palette.black};
    border-radius: 3px;
    background-color: ${props => props.$isDragOver ? '#e6f3ff' : colors.palette.greyscale5};
    padding: ${spacing.spacing4};
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    position: relative;
    
    &:hover {
        border-color: ${colors.btnPrimaryBG};
        background-color: #f0f8ff;
    }
    
    ${props => props.$isDragOver && `
        transform: scale(1.02);
        box-shadow: 0 4px 12px rgba(0, 102, 204, 0.2);
    `}
`;

const iconButtonStyle = {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
};

const NewFileNameContainer = styled.div<{ $background?: string; $minWidth?: string; $maxWidth?: string; }>`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background: '#E2F0F4';
    box-shadow: ${props => props.$background ? '' : '0px 1px 2px rgba(0, 0, 0, 0.25)'};
    padding: ${props => props.$background ? `${spacing.spacing2} ${spacing.spacing0}` : `${spacing.spacing2} ${spacing.spacing2} ${spacing.spacing2} ${spacing.spacing4}`};
    min-width: ${props => props.$minWidth || '300px'};
    gap: ${spacing.spacing4};
    max-width: ${props => props.$maxWidth || '400px'};
    width: 100%;
    font-size: 0.9rem;
    border-radius: 4px;
    border: 1px solid ${colors.palette.greyscale40};

    .close-icon {
        cursor: pointer;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
    }
`;

const NewFileNameDiv = styled.div`
    display: inline-block;
    width: 60%;
    background: #F2F2F2;
    align-items: flex-start;
    word-break: break-word;
    flex-wrap: wrap;
    gap: ${spacing.spacing1};

    svg: {
        width: 24px;
        height: 24px;
        path {
            fill: {colors.btnPrimaryBG};
        }
    }
`;

const NewFileSizeDiv = styled.div`
    width: 25%;
    display: inline-flex;
`;

const NewFileNameSizeDiv = styled.div`
    &:hover {
        border-radius: 4px;
        border: 1px solid ${colors.palette.greyscale40};
    }
`;

const NewFileActionDiv = styled.div`
    display: flex;
    width: 40%;
    align-items: flex-start;
    word-break: break-word;
    flex-wrap: wrap;
    gap: ${spacing.spacing1};

    svg: {
        width: 24px;
        height: 24px;
        path {
            fill: {colors.btnPrimaryBG};
        }
    }
`;

const NewIconButtonStyle = {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    paddingRight: '20px',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
};

export const StyledNewUploadedFileIcon = styled(UploadedFile)`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
`;

export const StyledNewViewFileIcon = styled(ViewFile)`
    flex-shrink: 0;
    path {
        fill: ${colors.palette.systemBlue};
    }

    width: 24px;
    height: 24px;
`;

export const StyledNewDeleteFileIcon = styled(DeleteFile)`
    flex-shrink: 0;
    path {
        fill: ${colors.palette.systemBlue};
    }

    width: 24px;
    height: 24px;
`;

export type UPloadFileItemProps = {
    file: File;
    attachment?: string;       // base64 content for default upload mode
    fileContent?: ArrayBuffer; // raw binary content for multiPart upload mode
    attachmentFRA?: string;
    path?: string;
    description?: string;
    size?: number;
    error?: string;
    hasError?: boolean;
    isXMLValid?: boolean;
    isLoading?: boolean;
};

export type FileUploadProps = {
    field: FormSectionElements;
    lang: 'en' | 'fr';
    title?: string;
    appName?: string;
    setFieldValue: (value: any) => void;
    callbackStepIndex?: (index: number, returnIndex?: number) => void;
    callbackValidate?: (errors: FormSectionElements[])=>void;
    callbackElement;
}

const FileUploadComponent = ({
    field,
    title, 
    appName,
    lang,
    setFieldValue,
    callbackStepIndex,
    callbackValidate,
    callbackElement
}: FileUploadProps) => {
    const [files, setFiles] = useState<UPloadFileItemProps[]>([]);
    const uploadRef = useRef(null);
    const [errors, setErrors] = useState<string[]>([]);
    const [totalFileSize, setTotalFileSize] = useState<number>(0);
    const [numberOfTries, setNumberOfTries] = useState<number>(0);
    const [loading, setLoading] = useState(false);
    const maxAttempBodyMessage = lang==="en"?`Please check your file and try again. Reminder, ${field.FileUpload?.maxWrongAttemps-numberOfTries>1?`you only have ${field.FileUpload?.maxWrongAttemps-numberOfTries} attempts left`:'this is your last attempt'}`: `Vérifiez le fichier et réessayez. Rappel : ${field.FileUpload?.maxWrongAttemps-numberOfTries>1?`Il ne vous reste que ${field.FileUpload?.maxWrongAttemps-numberOfTries===2?"deux":field?.FileUpload.maxWrongAttemps-numberOfTries} tentative`:'Il s’agit de votre dernière tentative.'}`;
    const [modalOpen, setModalOpen] = useState(false);
    //const [desc, setDesc] = useState('');
    const [current, setCurrent] = useState<UPloadFileItemProps|null>(null);
    const [modalType, setModalType] = useState<'Preview'|'Description'|null>(null);
    const [showFileErrorDialog, setShowFileErrorDialog] = useState(false);
    const [isDragOver, setIsDragOver] = useState(false);
    const [dragCounter, setDragCounter] = useState(0);
    const setGaUploadPause = (value: boolean) => {
        if (value) {
            sessionStorage.setItem("gaUploadPause", "true");
        } else {
            sessionStorage.removeItem("gaUploadPause");
        }
    };

    const KB = 1024;
    const unit = field.FileUpload?.SizeUnite || UploadFileSizeLimit.unite;
    const sizeLimit = (field.FileUpload?.FileSizeLimit || UploadFileSizeLimit.size) * 
        (unit === 'GB' ? KB * KB * KB : (unit === 'MB' ? KB * KB : KB));
    const unite = ['B', 'KB', 'MB', 'GB'];

    // useEffect(() => {
    //     setFieldValue(files);
    //     setErrors([]);
    // }, [files]);

    useEffect(() => {
        const initFiles = field.Value ?? [] as UPloadFileItemProps[];
        setFiles(initFiles);
        setTotalFileSize(initFiles.reduce((accumulator, file)=>{
            return accumulator + file.size;
        }, 0));
        if (field.Valid || !field.Touched) {
            setErrors([]);
        }
        setCurrent(null);
        setModalOpen(false);
    }, [field.Value]);

    useEffect(() => {
        console.log(field.ErrorMessage);
        // callbackValidate(["test eror"])
    }, [field.ErrorMessage, field.ErrorMessageFRA]);

    // Show error dialog ONLY when Validate/Next button is clicked (not during file upload)
    useEffect(() => {
        console.log('FileUpload validation check:', {
            uploadStyle: field.FileUpload?.UploadStyle,
            showDialog: field.ShowFileErrorDialog,
            hasErrors: files.some(file => file.hasError),
            valid: field.Valid,
            touched: field.Touched
        });

        // Only show dialog when ShowFileErrorDialog flag is explicitly set
        // This flag is set by FormValidationUtils when Next/Validate button is clicked
        if (field.FileUpload?.UploadStyle === 'inline-error' &&
            field.ShowFileErrorDialog === true &&
            files.some(file => file.hasError)) {
            console.log('Showing file error dialog');
            setShowFileErrorDialog(true);

            // Reset the flag
            field.ShowFileErrorDialog = false;
        }
    }, [field.ShowFileErrorDialog, field.Valid, files]);

    // Note: No scroll handling to avoid issues

    const fileList = field.FileUpload?.AllowedForUploadFileTypeList
        ?.map(type => type.label)
        .join(', ') ?? '';
    const allowedMimeTypes = Array.from(new Set(
        (field.FileUpload?.AllowedForUploadFileTypeList ?? [])
            .map(type => type?.val)
            .filter(Boolean)
            .flat()
            .map(item => item?.mimeType?.toLowerCase())
            .filter(Boolean)
    ));
    const allowedExtensions = Array.from(new Set(
        (field.FileUpload?.AllowedForUploadFileTypeList ?? [])
            .map(type => type?.val)
            .filter(Boolean)
            .flat()
            .map(item => item?.ext?.toLowerCase())
            .filter(Boolean)
    ));
    const uploadInputAccept = [
        ...allowedMimeTypes,
        ...allowedExtensions.map(ext => `.${ext}`)
    ].join(',');
    const isXmlOnlyUpload = allowedExtensions.length > 0 && allowedExtensions.every(ext => ext === 'xml');
    const fileTypePrefix = lang === 'en'
        ? field.FileUpload?.fileTypePrefix
        : field.FileUpload?.fileTypePrefixFRA ?? field.FileUpload?.fileTypePrefix;
    const fileListDisplay = `${fileTypePrefix ?? ''}${fileList}`;
    const previewVerticalAlign = !!field.FileUpload?.previewButtonVerticalAlign;
    const sizeUnit = field.FileUpload?.SizeUnite ? field.FileUpload.SizeUnite : 'MB';
    const sizeDivisor = sizeUnit === 'GB' ? KB * KB * KB : sizeUnit === 'MB' ? KB * KB : KB;
    const totalSizeValue = (totalFileSize / sizeDivisor).toFixed(2);
    const maxTotalSize = field.FileUpload?.FileSizeInTotal ?? 0;
    const maxFileCount = field.FileUpload?.maxFileCount;
    const totalFileSizeText = `${totalSizeValue}/${maxTotalSize} ${sizeUnit}`;

    const getFileType = (file?: File) => {
        return fileTypeList.filter(type => type.val.some(val => val.mimeType === file?.type))?.[0]?.label ?? '';
    }

    const getFileSize = (file: File) => {
        let size = file.size, index = 0;
        while(size > KB) {
            size = size/KB;
            if (++index === unite.length-1) {
                break;
            }
        }
        return size ? size.toFixed(2) + unite[index] : 0;
    }

    const getFileBaseName = (fileName: string): string => {
        if (!fileName) return '';
        const trimmed = fileName.trim().toLowerCase();
        const lastDotIndex = trimmed.lastIndexOf('.');
        return lastDotIndex > 0 ? trimmed.substring(0, lastDotIndex) : trimmed;
    }

    const getFileExtension = (fileName: string): string => {
        if (!fileName) return '';
        const trimmed = fileName.trim().toLowerCase();
        const lastDotIndex = trimmed.lastIndexOf('.');
        return lastDotIndex > -1 ? trimmed.substring(lastDotIndex + 1) : '';
    }

    const isXmlMimeType = (mimeType?: string): boolean => {
        return mimeType === 'text/xml' || mimeType === 'application/xml';
    }

    const isXmlFile = (file: File): boolean => {
        return isXmlMimeType(file.type?.toLowerCase()) || getFileExtension(file.name) === 'xml';
    }

    const hasDuplicateFileName = (file: File, existingFiles: UPloadFileItemProps[]): boolean => {
        const incomingBaseName = getFileBaseName(file.name);
        return existingFiles.some(existing => getFileBaseName(existing?.file?.name ?? '') === incomingBaseName);
    }

    const handleRemoveFile = (fileName: string, path: string) => {
        const newFiles = files.filter(file => file.file.name !== fileName || file.path !== path);
        if (uploadRef.current.value === path) {
            uploadRef.current.value = '';
        }
        setFieldValue(newFiles);
        setTotalFileSize(totalFileSize - files.filter(item => !newFiles.includes(item))[0].size);
        if(newFiles.length === 0)
            setTotalFileSize(0);
    };

    const handleRemoveFailedFiles = () => {
        // Remove only files with errors
        const newFiles = files.filter(file => !file.hasError);
        setFieldValue(newFiles);

        // Recalculate total file size
        const newTotalSize = newFiles.reduce((accumulator, file) => accumulator + file.size, 0);
        setTotalFileSize(newTotalSize);

        // Clear the error dialog
        setShowFileErrorDialog(false);

        // If all files are removed, clear validation state
        if (newFiles.length === 0) {
            field.Valid = true;
            field.ErrorMessage = '';
            field.ErrorMessageFRA = '';
        } else {
            // Check if there are still errors after removing failed files
            const hasErrors = newFiles.some(file => file.hasError);
            field.Valid = !hasErrors;
        }

        callbackValidate?.([field]);
    };

    const handleDragEnter = (e: React.DragEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragCounter(prev => prev + 1);
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragOver(true);
        }
    };

    const handleDragLeave = (e: React.DragEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragCounter(prev => prev - 1);
        if (dragCounter <= 1) {
            setIsDragOver(false);
        }
    };

    const handleDragOver = (e: React.DragEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer) {
            e.dataTransfer.dropEffect = 'copy';
        }
    };

    const handleDrop = (e: React.DragEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
        setDragCounter(0);

        const droppedFiles = Array.from(e.dataTransfer.files || []);
        if (droppedFiles.length > 0) {
            processFiles(droppedFiles);
        }
    };

    const processFiles = async (selectedFiles: File[]) => {
        if (!selectedFiles.length) return;
        setGaUploadPause(true);

        if (field.FileUpload?.maxFileCount && files.length >= field.FileUpload.maxFileCount) {
            const defaultErrorMsgEN = `You can only upload up to ${field.FileUpload.maxFileCount} file${field.FileUpload.maxFileCount > 1 ? 's' : ''}`;
            const defaultErrorMsgFR = `Vous ne pouvez télécharger que ${field.FileUpload.maxFileCount} fichier${field.FileUpload.maxFileCount > 1 ? 's' : ''} maximum`;

            const errorMsgEN = (field.FileUpload.maxFileCountErrorMessage || defaultErrorMsgEN).replace('{max}', field.FileUpload.maxFileCount.toString());
            const errorMsgFR = (field.FileUpload.maxFileCountErrorMessage || defaultErrorMsgFR).replace('{max}', field.FileUpload.maxFileCount.toString());

            field.ErrorMessage = errorMsgEN;
            field.ErrorMessageFRA = errorMsgFR;
            field.Valid = false;
            field.Touched = true;
            callbackValidate([field]);
            setGaUploadPause(false);
            return;
        }

        const path = 'drag-drop';
        const newFiles = [...files];
        let currentTotalSize = files.reduce((accumulator, file)=>{
            return accumulator + file.size;
        }, 0);

        const filesToAdd = selectedFiles.filter((file, index) => {
            return !field.FileUpload?.maxFileCount || newFiles.length + index < field.FileUpload.maxFileCount;
        });

        const loadingFiles = filesToAdd.map(file => {
            const hasXMLType = isXmlFile(file);
            return {
                file,
                path,
                attachment: '',
                size: file.size,
                hasError: false,
                isXMLValid: false,
                isLoading: hasXMLType && (field.FileUpload?.validateXML || isXmlOnlyUpload)
            };
        });

        newFiles.push(...loadingFiles);
        setFieldValue(newFiles);

        const isMultiPart = field.FileUpload?.multiPart === true;
        let hasXMLErrors = false;
        let hasNonXMLErrors = false;
        const existingFilesForDupCheck = [...files];

        try {
            for (let i = 0; i < filesToAdd.length; i++) {
                const file = filesToAdd[i];
                const fileIndex = files.length + i;

                const newTotalSize = currentTotalSize + file.size;
                const hasXMLType = isXmlFile(file);

                // multiPart: read raw binary (ArrayBuffer) + validate in parallel; no base64 encoding.
                // default: read as base64 data URL + validate in parallel.
                let validationResult: Awaited<ReturnType<typeof isFileValid>>;
                let attachment = '';
                let fileContent: ArrayBuffer | undefined;

                if (isMultiPart) {
                    [validationResult, fileContent] = await Promise.all([
                        isFileValid(file, path, newTotalSize, existingFilesForDupCheck),
                        readFileAsBuffer(file)
                    ]);
                } else {
                    [validationResult, attachment] = await Promise.all([
                        isFileValid(file, path, newTotalSize, existingFilesForDupCheck),
                        readFileContent(file)
                    ]);
                }

                const updatedFiles = [...newFiles];
                if (validationResult.valid) {
                    const isValidXML = hasXMLType && (field.FileUpload?.validateXML || isXmlOnlyUpload);
                    updatedFiles[fileIndex] = {
                        file,
                        path,
                        attachment,
                        fileContent,
                        size: file.size,
                        hasError: false,
                        isXMLValid: isValidXML,
                        isLoading: false
                    };
                    currentTotalSize = newTotalSize;
                    field.Valid = true;
                    field.IsEmpty = false;
                    existingFilesForDupCheck.push(updatedFiles[fileIndex]);
                } else if (validationResult.error) {
                    const isEmptyFile = file.size === 0;
                    if (!validationResult.remove) {
                        updatedFiles[fileIndex] = {
                            file,
                            path,
                            attachment,
                            fileContent,
                            size: file.size,
                            hasError: true,
                            error: validationResult.error,
                            isXMLValid: false,
                            isLoading: false
                        };
                        hasXMLErrors = true;

                        if (isEmptyFile) {
                            field.Valid = false;
                            field.Touched = true;
                        }
                    } else {
                        updatedFiles.splice(fileIndex, 1);
                        hasNonXMLErrors = true;
                    }
                } else if (validationResult.remove) {
                    updatedFiles.splice(fileIndex, 1);
                    hasNonXMLErrors = true;
                }

                setFieldValue(updatedFiles);
                setTotalFileSize(currentTotalSize);
                Object.assign(newFiles, updatedFiles);
            }

            if (hasXMLErrors) {
                field.Valid = false;
                field.Touched = true;

                if (!hasNonXMLErrors) {
                    field.ErrorMessage = '';
                    field.ErrorMessageFRA = '';
                }
            }

            if (!hasNonXMLErrors && !hasXMLErrors) {
                setErrors([]);
            }
        } finally {
            setGaUploadPause(false);
        }
    };

    function base64ToFile(base64, filename, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters).map(c => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
        return new File([blob], filename, { type: mimeType });
    }

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const IsFileCorrupt = async (file: File, fileName: string) => {

        setLoading(true);

        const formData = new FormData();
        formData.append('file', file); // The PDF file selected
        const blob = new Blob([file], { type: 'application/octet-stream' });

        let res:DSSScanResult | void;
        const scanID = await axios.post<DSSScanResponse>(getEnvVar('DSS_BASEURL')+`upload/stream?appcode=${appName}`, blob, {
            headers:{
                'Content-Type': 'application/octet-stream',
                'filename': encodeURI(file.name),
                "Ocp-Apim-Subscription-Key": getEnvVar('APIM_SUBSCRIPTION_KEY'),
                "DefenderScan-API-Key": getEnvVar('DSS_APIKEY'),
                "appCode": appName
            }
        })
        .then(data => data.data.scanId)
        .catch(error => {
            if (error?.message?.toLowerCase() === 'network error') {
                setLoading(false);
                return 'FORBIDDEN';
            }
            return null;
        });
        if (scanID === 'FORBIDDEN') {
            return {statusCode:403} as any;
        }
        while(!res || res.statusCode === 2){
            await delay(2000);
            res = await axios.get<DSSScanResult>(getEnvVar('DSS_BASEURL').concat('scan-result/{scanId}').replace('{scanId}', scanID), {
                    headers:{
                        "Ocp-Apim-Subscription-Key": getEnvVar('APIM_SUBSCRIPTION_KEY'),
                        "DefenderScan-API-Key": getEnvVar('DSS_APIKEY')
                    }
                })
                .then(res=>res.data)
                .catch(err=>console.error(err));
        }
        if(res){
            setLoading(false);
        }

        return res;
    }

    const validateXMLAttachments = (xmlContent: string, xmlDoc: Document): { valid: boolean; error?: string } => {
        const maxAttachmentSize = 20 * 1024 * 1024; // 20MB in bytes

        try {
            // Use DOM tree walker to iterate through text nodes
            // This is much more efficient than regex for large files
            const walker = document.createTreeWalker(
                xmlDoc,
                NodeFilter.SHOW_TEXT,
                null
            );

            let node;
            while (node = walker.nextNode()) {
                const textContent = node.textContent?.trim() || '';

                // Skip small text nodes
                if (textContent.length < 100) continue;

                // Check if it looks like base64 (mostly alphanumeric with +/= chars)
                // Use a simple test without complex regex
                const base64Pattern = /^[A-Za-z0-9+/]+=*$/;
                if (base64Pattern.test(textContent)) {
                    // Calculate the approximate size of the decoded content
                    const decodedSize = (textContent.length * 3) / 4;
                    const paddingMatches = textContent.match(/=+$/);
                    const padding = paddingMatches ? paddingMatches[0].length : 0;
                    const actualSize = decodedSize - padding;

                    if (actualSize > maxAttachmentSize) {
                        return {
                            valid: false,
                            error: `XML contains an attachment larger than 20MB (approximately ${(actualSize / (1024 * 1024)).toFixed(2)}MB)`
                        };
                    }
                }
            }

            return { valid: true };
        } catch (error) {
            // If tree walker fails, just skip validation and allow the file
            return { valid: true };
        }
    };

    const validateXMLFile = async (file: File): Promise<{ valid: boolean; error?: string }> => {
        const hasXMLType = isXmlFile(file);

        // Only validate XML content for XML files
        if (!hasXMLType) {
            return { valid: true };
        }

        // Skip XML validation only when not explicitly enabled and not XML-only upload
        if (!field.FileUpload?.validateXML && !isXmlOnlyUpload) {
            return { valid: true };
        }

        try {
            // Read file content as text
            const text = await file.text();

            // Parse XML using DOMParser
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(text, 'text/xml');

            // Check for parsing errors
            const parserError = xmlDoc.getElementsByTagName('parsererror');
            if (parserError.length > 0) {
                return { valid: false, error: 'XML is not well-formed' };
            }

            // Validate attachment sizes using the parsed DOM
            const attachmentResult = validateXMLAttachments(text, xmlDoc);
            if (!attachmentResult.valid) {
                return attachmentResult;
            }

            return { valid: true };
        } catch (error) {
            return { valid: false, error: `Failed to process XML file: ${error?.message}` };
        }
    };

    const duplicateErrorMsgEN = 'You have already uploaded a file with the same name. Please rename your file before uploading.';
    const duplicateErrorMsgFR = 'Vous avez deja televerse un fichier portant le meme nom. Veuillez renommer votre fichier avant de le televerser.';

    const isFileValid = async (file: File, path: string, totalSize: number, existingFiles: UPloadFileItemProps[] = files): Promise<{ valid: boolean; error?: string; remove?: boolean }> => {
        let inValid = [];
        const permittedTotalFileSize = field.FileUpload?.FileSizeInTotal ? field.FileUpload.FileSizeInTotal * (field.FileUpload?.SizeUnite === 'GB' ? KB * KB * KB : KB * KB) : Infinity;

        // Check for empty file (size = 0) - keep file in list with error
        if (file.size === 0) {
            const emptyFileError = lang === 'en'
                ? 'The file is empty. Please upload a file with content.'
                : 'Le fichier est vide. Veuillez téléverser un fichier avec du contenu.';
            return { valid: false, error: emptyFileError };
        }

          if(file.name.length > 30 && field.FileUpload?.isBXPCustomErrorMessage){
                let fileTooLargeMessageEn = 'File name including extension must be in letters or numbers and not exceed 30 characters.';
                let   fileTooLargeMessageFr = 'Le nom du fichier, y compris l\'extension, doit être en lettres ou en chiffres et ne pas dépasser 30 caractères.';
                field.ErrorMessage = fileTooLargeMessageEn;
                field.ErrorMessageFRA = fileTooLargeMessageFr;
                field.Valid = false;
                field.Touched = true;
                field.popupError = true; 
                callbackElement(getRootComponent(field));
                inValid.push(`${lang==='en'? fileTooLargeMessageEn : fileTooLargeMessageFr}`);
            }

        if(field.FileUpload?.allowDuplicateName !== true){
            if (files?.filter(f => f.path === path && file.name === f.file.name).length) {
                return { valid: false, remove: true };
            }
        }

        if (field.FileUpload?.allowDuplicateName !== true && hasDuplicateFileName(file, existingFiles)) {
            const duplicateMessage = lang === 'en' ? duplicateErrorMsgEN : duplicateErrorMsgFR;
            setErrors([duplicateMessage]);
            field.isContinueFile = false;
            field.ErrorMessage = '';
            field.ErrorMessageFRA = '';
            field.Valid = false;
            field.Touched = true;
            callbackValidate([field]);
            return { valid: false, error: duplicateMessage, remove: true };
        }

        // Validate XML files for well-formed structure and attachment size
        const xmlValidation = await validateXMLFile(file);
        if (!xmlValidation.valid) {
            // For XML files, we show inline errors only - do NOT set field-level validation errors
            // This prevents the error from appearing at the top of the page
            return { valid: false, error: xmlValidation.error };
        }

        // Check if this is an XML file with validation enabled
        const hasXMLType = isXmlFile(file);
        const isXMLValidationEnabled = field.FileUpload?.validateXML;

        if (file.size > sizeLimit || totalSize>permittedTotalFileSize) {
            // For XML files with validation enabled, show specific error message inline only
            if (hasXMLType && (isXMLValidationEnabled || isXmlOnlyUpload)) {
                const sizeUnit = field.FileUpload?.SizeUnite ?? "MB";
                const sizeLimit = field.FileUpload?.FileSizeLimit || UploadFileSizeLimit.size;
                const errorMsg = lang === 'en'
                    ? `File too big! Max ${sizeLimit} ${sizeUnit} per attachment.`
                    : `Fichier trop volumineux! Max ${sizeLimit} ${sizeUnit === 'MB' ? 'Mo' : 'Go'} par pièce jointe.`;
                return { valid: false, error: errorMsg };
            }

            // For non-XML files, show field-level error at the top
            field.isContinueFile=false;

            let fileTooLargeMessageEn = `We can accept up to ${maxFileCount} files for a total of ${field.FileUpload?.FileSizeLimit} ${field.FileUpload?.SizeUnite ?? "MB"}`;
            let fileTooLargeMessageFr = `Nous pouvons accepter jusqu’à ${maxFileCount} fichiers pour un total de ${field.FileUpload?.FileSizeLimit || UploadFileSizeLimit.size} ${(field.FileUpload?.SizeUnite ?? UploadFileSizeLimit.unite) == "MB" ? lang.includes('en') ? "MB" : "Mo" : "GB"}`;
            
            if(field.FileUpload?.isBXPCustomErrorMessage){
                fileTooLargeMessageEn = 'You may not attach files with a total size larger than 7 MB';
                fileTooLargeMessageFr = 'Vous ne pouvez pas joindre des fichiers dont la taille totale dépasse 7 Mo';
            }
            field.ErrorMessage = field.FileUpload.FileSizeExceedErrorENU ?? fileTooLargeMessageEn;
            field.ErrorMessageFRA = field.FileUpload.FileSizeExceedErrorFRA ?? fileTooLargeMessageFr;
            field.Valid = false;
            field.Touched = true;
            field.popupError = !field.FileUpload.hidePopup && true; 
            callbackElement(getRootComponent(field));
            //callbackValidate([field]);
            inValid.push(`${lang==='en'? fileTooLargeMessageEn : fileTooLargeMessageFr}`);
        }
        
        // Checks for jfif and exif format of jpeg
        let isJpegValid = true;
        if(file.type === "image/jpeg"){
            if(!/\.jpe?g$/i.test(file.name)){
                isJpegValid = false;
            }
        }

        const normalizedMimeType = file.type?.toLowerCase() ?? '';
        const fileExtension = getFileExtension(file.name);
        const supportByMime = normalizedMimeType ? allowedMimeTypes.includes(normalizedMimeType) : false;
        const supportByExtension = fileExtension ? allowedExtensions.includes(fileExtension) : false;
        const support = supportByMime && supportByExtension;
            
        if (!support || !isJpegValid) {
            if(field.FileUpload.maxWrongAttemps && numberOfTries+1>=field.FileUpload.maxWrongAttemps){
                callbackStepIndex(field.FileUpload.indexAfterMaxAttempts);
            }
            setNumberOfTries(numberOfTries+1);
            field.isContinueFile=false;
            field.FileUpload?.AllowedForUploadFileTypeList;
            const allowedTypes =  field.FileUpload?.AllowedForUploadFileTypeList?.map(item => item.label).join(', ') ?? '';
            const invalidFileFormatMessageEn = `This system cannot accept the file format you provided. Please provide one of the following: ${allowedTypes}.`;
            const invalidFileFormatMessageFr = `Ce système ne peut pas accepter le format de fichier que vous avez fourni. Veuillez fournir les fichiers dans l’un des formats suivants : ${allowedTypes}.`;
            field.ErrorMessage = invalidFileFormatMessageEn;
            field.ErrorMessageFRA = invalidFileFormatMessageFr;
            field.Valid = false;
            field.Touched = true;
            field.popupError = true; 
            callbackElement(getRootComponent(field));
            inValid.push(`${lang==='en'? invalidFileFormatMessageEn : invalidFileFormatMessageFr}`);
        }

        if(field.FileUpload.fileScanOnUpload){
            const res = await IsFileCorrupt(file, file.name);
            if(res.statusCode !== 0){
                if(field.FileUpload.maxWrongAttemps && numberOfTries+1>=field.FileUpload.maxWrongAttemps){
                    callbackStepIndex(field.FileUpload.indexAfterMaxAttempts);
                }
                setNumberOfTries(numberOfTries+1);
                inValid.push(lang ==="en"?"Please check the file and try again.": "Veuillez vérifier le fichier et réessayer.");
            }
        }

        if (inValid.length > 0) {
            return { valid: false, error: inValid[0], remove: true };
        }
        return { valid: true };
    }
    const convertArrayBufferToString = (input: string | ArrayBuffer) => {
        if (typeof input == 'string') {
            return input;
        } else {
            const textDecoder = new TextDecoder('utf-8'); 
            const text = textDecoder.decode(input);
            return text;
        }
    }
    const handleFileUploadChange = async (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = Array.from(e.target.files || []);
        if (selectedFiles.length > 0) {
            await processFiles(selectedFiles);
        }
        e.target.value = '';
    }

    const readFileAsBuffer = (file: File): Promise<ArrayBuffer> => {
        return new Promise<ArrayBuffer>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = () => resolve(reader.result as ArrayBuffer);
            reader.onerror = () => reject(reader.error);
        });
    };

    const readFileContent = async (file) => {
        let content;
        var reader = new FileReader();

        const readFile = () => {
            return new Promise<void>((resolve, reject) => {
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    content = reader.result;
                    // Strip data URI header for XML files to avoid WAF blocking
                    if (isXmlFile(file)) {
                        content = (content as string).replace(/^data:(text|application)\/xml;base64,/, '');
                    }
                    resolve();
                }

                reader.onerror = function (e) {
                    reject(e);
                };
            })
        }

        await readFile();

        return content;
    }

    const handleAttachmentChange = (e: ChangeEvent<HTMLInputElement>, findex: number) => {
        const newFiles = files.map((file, index) => (index === findex ? lang==='en'? {...file, attachment: e.target.value} : {...file, attachmentFRA: e.target.value} : file));
        setFieldValue(newFiles);
    }

    const handleDescriptionChange = (e: ChangeEvent<HTMLInputElement>, findex: number) => {
        const newFiles = files.map((file, index) => (index === findex ?{...file, description: e.target.value} : file));
        setFieldValue(newFiles);
    }

    const handlePreviewFile = (file: UPloadFileItemProps) => {
        setModalType('Preview');
        setCurrent(file);
        setModalOpen(true);
    }

    const handleCloseModal = () => {
        setCurrent(null);
        setModalType(null);
        setModalOpen(false);
    }

    const handleDescription = (file: UPloadFileItemProps) => {
        //console.log(`file description: ${file.attachment}`);
        setCurrent(file);
        setModalType('Description');
        setModalOpen(true);
    }

    const handleUpdateDescription = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        const newFiles = files.map(file => (file.file.name === current.file.name ? lang==='en' ? {...file, attatchment: current.attachment} : {...file, attatchmentFRA: current.attachment} : file));
        setFieldValue(newFiles);
        handleCloseModal();
    }

    console.log(getFileType(current?.file).toLowerCase());

    return ( 
        <>
            {loading && 
                <LoadingOverlay
                    active={loading}
                    spinner
                    text={lang ==='en'?"Processing":"Traitement"}
                    styles={{
                        wrapper: {
                        position: 'fixed',
                        width: '100vw',
                        height: '100vh',
                        top: 0,
                        left: 0,
                        zIndex: 9999
                        },
                        overlay: (base) => ({
                        ...base,
                        background: 'rgba(0, 0, 0, 0.5)'
                        }),
                    }}
                ></LoadingOverlay>
            }
            <ModalComponent modalIsOpen={modalOpen} 
                shouldCloseOnOverlayClick 
                onRequestClose={handleCloseModal} 
                fileViewer={['pdf', 'word', 'excel'].includes(getFileType(current?.file).toLowerCase())}
            >
                {modalType === 'Preview' && (
                    <>
                        {['png', 'gif', "jpeg"].includes(getFileType(current.file).toLowerCase()) && (
                            <ImageViewerComponent filename={current.file.name} imageData={current.attachment} imageType={getFileType(current.file)} onClose={handleCloseModal}/>
                        )}
                        {getFileType(current.file).toLowerCase() === 'pdf' && (
                            <PDFViewerComponent filename={current.file.name} pdfContent={current.attachment} onClose={handleCloseModal} />
                        )}
                        {getFileType(current.file).toLowerCase()==='word' && (
                            <MsDocViewer docData={current.attachment} fileName={current.file.name} onClose={handleCloseModal} />
                        )}
                    </>
                )}
                {modalType === 'Description' &&  (
                    <>
                        <p>
                            <label htmlFor={`file-description-${field.Id}`}>
                                <strong>{(lang==='en' ? 'File description for ' : 'Description du fichier pour ') + current?.file.name}</strong>{lang==='en'? ' (optional)': ' (facultatif)'}
                            </label>
                        </p>
                        <InputText 
                            id={`attachement-${field.Id}`}
                            value={lang==='en' ? current.attachment : current.attachmentFRA}
                            type="text"
                            maxLength={250}
                            onChange={(e) => setCurrent(lang==='en' ? {...current, attachment: e.target.value}: {...current, attachmentFRA: e.target.value})}
                            style={{width: '100%', marginBottom: '-8px', border: '1px solid #0066cc'}}
                        />

                        <div className="ontario-margin-top-32-!" style={{display: 'flex'}}>
                            <button className="ontario-button ontario-button--primary" onClick={handleUpdateDescription}>Ok</button> 
                            <button className="ontario-button ontario-button--secondary" onClick={handleCloseModal}>{lang==='en'? 'Cancel' : 'Annuler'}</button>
                        </div>
                    </>
                )}
            </ModalComponent>

            <DocumentUploadContainer>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '500px'}}>
                    {numberOfTries>0 && field.FileUpload.maxWrongAttemps && (<WarningAlertComponent title={lang==="en"?"Notice":"Avis"} bodyMsg={maxAttempBodyMessage} Visible isEng={lang==="en"}/>)}
                    {title && <h2>{title}</h2>}

                    {((lang==='en' && field.ENUTitle) || (lang==='fr' && field.FRATitle)) && (
                        <label className="ontario-label">
                            {lang==='en' ? field.ENUTitle : field.FRATitle}
                            <span className="ontario-label__flag">
                                { field.Optional==='Y' ?
                                    getRootComponent(field).HideOptionalText == 'Y' ? '' : getRootComponent(field).UseAsterisks == 'Y'? '' : lang==='en' ? '(optional)' : '(facultatif)' :
                                    getRootComponent(field).UseAsterisks == 'Y' ? <span style={{color:'red'}}>*</span> : lang==='en' ? '(required)': '(obligatoire)'
                                }
                            </span>
                        </label>
                    )}
                    {(lang==='en' ? field.Hint : field.HintFR) && (
                        <div className="ontario-margin-bottom-16-!" dangerouslySetInnerHTML={{__html: lang==='en' ? field.Hint : field.HintFR}} />
                    )}
                    {field.hintExpansionTitle && <HintExpansionComponent
                        isEng={lang==='en'}
                        calloutType={field.callOutBoxType}
                        Visible={true}
                        bodyMsg={lang==='en' ? field.callOutBoxBody : field.callOutBoxBodyFRA}
                        title={lang==='en' ? field.callOutBoxTitle : field.callOutBoxTitleFRA}
                        hintExpansionTitle={lang==='en' ? field.hintExpansionTitle : field.hintExpansionTitleFRA}
                        field={field}/>}
                    <LiveValidationErrMsg
                        field={field}
                        isEng={lang==='en'}
                        key={"LiveValidationErrMsg_" + field.LoadBindName}
                    />

                    {errors.length>0 && (
                        <div className="ontario-margin-top-16-!">
                            <ErrorElement message={errors.join('; ')} display />
                        </div>
                    )}
                </div>
            </DocumentUploadContainer>

                    {files.length>0 && (
                    <div className="ontario-margin-top-32-! ontario-margin-bottom-16-!">
                        <div className="ontario-margin-top-16-!">
                            {files.map((file, index) => (
                                !file.file ? null : (
                                <div className="upload-item" style={getStyleObjectFromString(field.InlineStyle)}>
                                    <div className="ontario-columns ontario-small-12">
                                        {file.hasError && file.error && (
                                            <div className="ontario-error-messaging">
                                                <span className="ontario-error__text">{file.error}</span>
                                            </div>
                                        )}
                                        {field.FileUpload?.UploadedFileDisplayStyle !== 'new' && <FileNameContainer $maxWidth={!field.FileUpload?.LegacyStyle ? '500px' : ''}>
                                            <FileNameDiv>
                                                {(() => {
                                                    // Treat undefined as 'default' for backward compatibility
                                                    const uploadStyle = field.FileUpload?.UploadStyle || 'default';
                                                    const showStatusIcons = uploadStyle === 'inline-error';

                                                    if (showStatusIcons) {
                                                        // inline-error style: show status icons for ALL files
                                                        if (file.isLoading) {
                                                            return (
                                                                <StyledStatusIcon className="ontario-icon-loading" style={{ background: 'transparent' }}>
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                        <style>
                                                                            {`
                                                                                @keyframes spinner {
                                                                                    0% { transform: rotate(0deg); }
                                                                                    100% { transform: rotate(360deg); }
                                                                                }
                                                                                .spinner { animation: spinner 1s linear infinite; transform-origin: center; }
                                                                            `}
                                                                        </style>
                                                                        <circle className="spinner" cx="12" cy="12" r="10" fill="none" stroke="#0066cc" strokeWidth="3" strokeDasharray="31.4 31.4" strokeDashoffset="10" strokeLinecap="round"/>
                                                                    </svg>
                                                                </StyledStatusIcon>
                                                            );
                                                        } else if (file.hasError && file.error) {
                                                            return (
                                                                <StyledStatusIcon className="ontario-icon-error">
                                                                    !
                                                                </StyledStatusIcon>
                                                            );
                                                        } else {
                                                            return (
                                                                <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24"
                                                                    preserveAspectRatio="xMidYMid meet"
                                                                    style={{ width: '24px', height: '24px', flexShrink: 0 }}>
                                                                    <use href="#ontario-icon-alert-success"></use>
                                                                </svg>
                                                            );
                                                        }
                                                    }

                                                    // default style: show photo icon for ALL files
                                                    return (
                                                        <StyledPhotoIcon
                                                            className="ontario-icon"
                                                            preserveAspectRatio="xMidYMid meet"
                                                        />
                                                    );
                                                })()}
                                                <span>{file.file.name}</span>
                                            </FileNameDiv>
                                            <FileNameDiv>
                                                <span>{getFileSize(file.file)}</span>

                                                {field.FileUpload?.PreviewFile && !field.FileUpload?.LegacyStyle && !previewVerticalAlign && (
                                                    <button
                                                        type="button"
                                                        aria-label={lang === 'en' ? 'Preview File' : 'Aperçu'}
                                                        title={lang === 'en' ? 'Preview' : 'Aperçu'}
                                                        onClick={() => handlePreviewFile(file)}
                                                        style={iconButtonStyle}
                                                    >
                                                        <VscPreview
                                                            style={{ fill: "#0066cc", height: '24px', width: '24px' }}
                                                            aria-hidden="true"
                                                            focusable="false"
                                                        />
                                                    </button>
                                                )}

                                                {field.FileUpload?.hasDescription && !field.FileUpload?.LegacyStyle && (
                                                    <button
                                                        type="button"
                                                        aria-label={lang === 'en' ? (file.attachment || 'Description') : (file.attachment || 'Description')}
                                                        title={lang === 'en' ? (file.attachment || 'Description') : (file.attachment || 'Description')}
                                                        onClick={() => handleDescription(file)}
                                                        style={iconButtonStyle}
                                                    >
                                                        <SlNote
                                                            style={{ fill: "#0066cc", height: '20px', width: '20px', marginTop: '1px' }}
                                                            aria-hidden="true"
                                                            focusable="false"
                                                        />
                                                    </button>
                                                )}

                                                <button
                                                    type="button"
                                                    aria-label={lang === 'en' ? 'Remove File' : 'Supprimer'}
                                                    title={lang === 'en' ? 'Delete' : 'Supprimer'}
                                                    onClick={() => handleRemoveFile(file.file.name, file.path)}
                                                    style={iconButtonStyle}
                                                >
                                                    <CloseIcon
                                                        style={{ fill: "#0066cc", height: '24px', width: '24px' }}
                                                        aria-hidden="true"
                                                        focusable="false"
                                                    />
                                                </button>
                                            </FileNameDiv>
                                        </FileNameContainer>}

                                        {field.FileUpload?.UploadedFileDisplayStyle === 'new' && <NewFileNameContainer $maxWidth={!field.FileUpload?.LegacyStyle ? '80%' : ''}>
                                            <div style={{ background: '#F2F2F2', width: '60%' }}>
                                                <NewFileNameSizeDiv>
                                                    <NewFileNameDiv>
                                                        {(() => {
                                                            // Treat undefined as 'default' for backward compatibility
                                                            const uploadStyle = field.FileUpload?.UploadStyle || 'default';
                                                            const showStatusIcons = uploadStyle === 'inline-error';

                                                            if (showStatusIcons) {
                                                                // inline-error style: show status icons for ALL files
                                                                if (file.isLoading) {
                                                                    return (
                                                                        <StyledStatusIcon className="ontario-icon-loading" style={{ background: 'transparent' }}>
                                                                            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                                <style>
                                                                                    {`
                                                                                        @keyframes spinner {
                                                                                            0% { transform: rotate(0deg); }
                                                                                            100% { transform: rotate(360deg); }
                                                                                        }
                                                                                        .spinner { animation: spinner 1s linear infinite; transform-origin: center; }
                                                                                    `}
                                                                                </style>
                                                                                <circle className="spinner" cx="12" cy="12" r="10" fill="none" stroke="#0066cc" strokeWidth="3" strokeDasharray="31.4 31.4" strokeDashoffset="10" strokeLinecap="round"/>
                                                                            </svg>
                                                                        </StyledStatusIcon>
                                                                    );
                                                                } else if (file.hasError && file.error) {
                                                                    return (
                                                                        <StyledStatusIcon className="ontario-icon-error">
                                                                            !
                                                                        </StyledStatusIcon>
                                                                    );
                                                                } else {
                                                                    return (
                                                                        <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24"
                                                                            preserveAspectRatio="xMidYMid meet"
                                                                            style={{ width: '24px', height: '24px', flexShrink: 0 }}>
                                                                            <use href="#ontario-icon-alert-success"></use>
                                                                        </svg>
                                                                    );
                                                                }
                                                            }

                                                            // default style: show photo icon for ALL files
                                                            return (
                                                                <StyledNewUploadedFileIcon
                                                                    className="ontario-icon"
                                                                    preserveAspectRatio="xMidYMid meet"
                                                                />
                                                            );
                                                        })()}
                                                        <span>{file.file.name}</span>
                                                    </NewFileNameDiv>
                                                    <NewFileSizeDiv>
                                                        <span>{getFileSize(file.file)}</span>
                                                    </NewFileSizeDiv>
                                                </NewFileNameSizeDiv>
                                            </div>
                                            <NewFileActionDiv>
                                                {field.FileUpload?.PreviewFile && !field.FileUpload?.LegacyStyle && !previewVerticalAlign && (
                                                    <button
                                                        type="button"
                                                        aria-label={lang === 'en' ? 'Preview File' : 'Aperçu'}
                                                        title={lang === 'en' ? 'Preview' : 'Aperçu'}
                                                        onClick={() => handlePreviewFile(file)}
                                                        style={NewIconButtonStyle}
                                                    >
                                                        <StyledNewViewFileIcon
                                                            className="ontario-icon"
                                                            preserveAspectRatio="xMidYMid meet"
                                                        />
                                                        Preview
                                                    </button>
                                                )}
                                                <button
                                                    type="button"
                                                    aria-label={lang === 'en' ? 'Remove File' : 'Supprimer'}
                                                    title={lang === 'en' ? 'Remove' : 'Retirer'}
                                                    onClick={() => handleRemoveFile(file.file.name, file.path)}
                                                    style={NewIconButtonStyle}
                                                >
                                                    <StyledNewDeleteFileIcon
                                                        className="ontario-icon"
                                                        preserveAspectRatio="xMidYMid meet"
                                                    />
                                                    Remove
                                                </button>
                                            </NewFileActionDiv>
                                        </NewFileNameContainer>}
                                    </div>
                                    <p hidden>{file.attachment}</p>
                                    {field.FileUpload?.LegacyStyle && field.FileUpload?.hasDescription && (
                                        <FileNameContainer $background="#ffffff" $minWidth="300px">
                                            <div style={{display: 'block', width: '100%'}}>
                                                <label htmlFor={`attachement-${field.Id}-${index}`}>
                                                    <strong>{lang==='en'? 'File description' : 'Description du fichier'}</strong>{lang==='en'? ' (optional)': ' (facultatif)'}
                                                </label>
                                                <InputText
                                                    id={`attachement-${field.Id}-${index}`}
                                                    type="text"
                                                    maxLength={250}
                                                    onChange={(e) => handleDescriptionChange(e, index)}
                                                    style={{width: '100%', marginBottom: '-8px', border: '1px solid #0066cc'}}
                                                    value={file.description}
                                                />
                                            </div>
                                        </FileNameContainer>
                                    )}
                                    {field.FileUpload?.LegacyStyle && field.FileUpload?.PreviewFile && !previewVerticalAlign && (
                                        <FileNameContainer $background="#ffffff" $minWidth="5rem" $maxWidth="14rem">
                                            <button className="ontario-button ontario-button--secondary"
                                                style={{marginBottom: '-6px', lineHeight: '1.3', color: '#0066cc', borderRadius: '4px', padding: '0.5rem 1rem' }}
                                                onClick={() => handlePreviewFile(file)}
                                            >{lang === "en"?"Preview File":"Aperçu du fichier"}</button>
                                        </FileNameContainer>
                                    )}
                                    {field.FileUpload?.PreviewFile && previewVerticalAlign && (
                                        <div
                                            className="ontario-margin-top-8-!"
                                            style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}
                                        >
                                            <button
                                                type="button"
                                                className="ontario-button ontario-button--secondary"
                                                style={{ lineHeight: '1.3', color: '#0066cc', borderRadius: '4px', padding: '0.5rem 1rem' }}
                                                onClick={() => handlePreviewFile(file)}
                                            >
                                                {lang === "en"?"Preview File":"Aperçu du fichier"}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )))}
                        </div>
                    </div>
            )}
                {files.length > 0 && (
                    <div>
                        {field.FileUpload?.UploadStyle === 'inline-error' ? (
                            <p>{lang==='en'? `You have uploaded ${files.length} file${files.length !== 1 ? 's' : ''}.`: `Vous avez téléchargé ${files.length} fichier${files.length !== 1 ? 's' : ''}.`}</p>
                        ) : (
                            <>
                                <p style={{ fontWeight: 600 }}>
                                    {lang==='en'
                                        ? `Total size for ${files.length} file${files.length !== 1 ? 's' : ''}: `
                                        : `Taille totale pour ${files.length} fichier${files.length !== 1 ? 's' : ''} : `}
                                    {totalFileSizeText}
                                </p>
                            </>
                        )}
                    </div>
                )}

                <div className="ontario-margin-top-16-! ontario-margin-bottom-16-!">
                    <UploadButton
                        type="button"
                        id={field.LoadBindName}
                        onClick={() => uploadRef.current.click()}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        $isDragOver={isDragOver}
                    >
                        <div style={{display: 'flex'}}>
                            <div style={{marginRight: '0.5rem'}}>
                                <UploadIcon fill={isDragOver ? '#0066CC' : '#0066CC'} style={{width: '24px', height: '24px' }}/>
                            </div>
                            <div>
                                <p style={{textAlign: 'left', fontSize: '20px', fontWeight: '700', marginBottom: '0.5rem', color: isDragOver ? '#0066CC' : '#0066CC'}}>
                                    <strong>
                                        {isDragOver 
                                            ? (lang==='en'? 'Drop files here': 'Déposez les fichiers ici')
                                            : (lang==='en'? 'Upload files or drag and drop': 'Téléchargement de fichiers ou utilisez la fonction glisser-déposer')
                                        }
                                    </strong>
                                </p>
                                <p style={{textAlign: 'left', fontSize: '17', marginBottom: '0.5rem'}}>
                                    {isDragOver 
                                        ? (lang==='en'? 'Release to upload multiple files': 'Relâchez pour télécharger plusieurs fichiers')
                                        : (fileListDisplay + (lang==='en'? ', max size ' : ', taille maximale ') + (field.FileUpload?.FileSizeLimit || UploadFileSizeLimit.size) + 
                                            ((field.FileUpload?.SizeUnite ?? UploadFileSizeLimit.unite) === "MB" ? (lang === "en" ? "MB" : "Mo") : (field.FileUpload?.SizeUnite === "GB" ? (lang === "en" ? "GB" : "Go") : (lang === "en" ? "KB" : "Ko"))))
                                    }
                                </p>
                            </div>
                        </div>
                    </UploadButton>
                    <input style={{display: 'none'}} id={`upload-file-${field.Id}`} type="file" accept={uploadInputAccept || undefined} ref={uploadRef} onChange={(e) =>handleFileUploadChange(e)} multiple={field.FileUpload?.multipleFiles} />
                </div>

            {/* File Error Dialog for inline-error mode - Ontario Design System */}
            {showFileErrorDialog && field.FileUpload?.UploadStyle === 'inline-error' && (
                <div
                    className="ontario-file-error-dialog-overlay"
                    onClick={() => setShowFileErrorDialog(false)}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="file-error-dialog-title"
                >
                    <div className="ontario-file-error-dialog" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="ontario-file-error-dialog__close"
                            onClick={() => setShowFileErrorDialog(false)}
                            aria-label={lang === 'en' ? 'Close dialog' : 'Fermer la boîte de dialogue'}
                            type="button"
                        >
                            ×
                        </button>
                        <h4 className="ontario-file-error-dialog__heading" id="file-error-dialog-title">
                            {lang === 'en' ? 'File error detected' : 'Erreur de fichier détectée'}
                        </h4>
                        <p className="ontario-file-error-dialog__body">
                            {lang === 'en'
                                ? 'The uploaded file contains an error and cannot be submitted. Please remove the file and/or upload a valid version to continue.'
                                : 'Le fichier téléchargé contient une erreur et ne peut pas être soumis. Veuillez supprimer le fichier et/ou télécharger une version valide pour continuer.'}
                        </p>
                        <div className="ontario-file-error-dialog__actions">
                            <button
                                className="ontario-button ontario-button--primary"
                                onClick={handleRemoveFailedFiles}
                                type="button"
                            >
                                {lang === 'en' ? 'Remove file' : 'Supprimer le fichier'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
};

export default FileUploadComponent;
